import React, {useEffect, useState} from "react";

const Sidebar = (props) => {

  const {
    addRemoveActivity,
    addRemoveRange,
    addRemoveColor,
    addRemoveTwoTone,
    addRemoveFibre,
    addRemoveTags,
    addRemoveSizes,
    addRemoveStyles,
    addRemoveWeights,
    hasTwoToneSelected,
    closeFilters,
    settings,
    opened,
  } = props;

  const {
    activities,
    ranges,
    fibre,
    colors,
    two_tones,
    tags,
    sizes,
    styles,
    weights
  } = settings;

  const [twoToneSelected, setTwoTonesSelected] = useState();

  useEffect(() => {
    setTwoTonesSelected(hasTwoToneSelected)
  }, [])


  return <div className="product-index__sidebar">
    <div className={`filter-sidebar ${opened ? 'is-active' : ''}`}>
                <span className="filter-sidebar__close"
                      onClick={closeFilters}/>
      <h5 className="filter-sidebar__title">Filters</h5>

      <div className="filter-sidebar-align">
        {activities.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Activity</h5>
          <ul>
            {activities.map((activity) => {
              return <li key={'activity_' + activity.id}>
                <input type="checkbox"
                       id={'activity__' + activity.id}
                       checked={props.activities.indexOf(activity.id) >= 0} />
                <label
                  htmlFor={'activity__' + activity.id}
                  onClick={() => { addRemoveActivity(activity.id) }}
                >{activity.title}</label>
              </li>
            })}

          </ul>
        </div>}
        {ranges.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Range</h5>
          <ul>
            {ranges.map((range) => {
              return <li key={'activity_' + range.id}>
                <input type="checkbox" id={'range__' + range.id}
                       checked={props.ranges.indexOf(range.id) >= 0} />
                <label
                  htmlFor={'range__' + range.id}
                  onClick={() => { addRemoveRange(range.id) }}
                >{range.title}</label>
              </li>
            })}
          </ul>
        </div>}
        {sizes.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Size</h5>
          <ul>
            {sizes.map((size) => {
              return <li key={'activity_' + size.id}>
                <input type="checkbox" id={'range__' + size.id}
                       checked={props.sizes.indexOf(size.id) >= 0} />
                <label
                  htmlFor={'range__' + size.id}
                  onClick={() => { addRemoveSizes(size.id) }}
                >{size.title}</label>
              </li>
            })}
          </ul>
        </div>}
        {styles.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Style</h5>
          <ul>
            {styles.map((style) => {
              return <li key={'activity_' + style.id}>
                <input type="checkbox" id={'range__' + style.id}
                       checked={props.styles.indexOf(style.id) >= 0} />
                <label
                  htmlFor={'range__' + style.id}
                  onClick={() => { addRemoveStyles(style.id) }}
                >{style.title}</label>
              </li>
            })}
          </ul>
        </div>}
        {weights.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Weight</h5>
          <ul>
            {weights.map((weight) => {
              return <li key={'activity_' + weight.id}>
                <input type="checkbox" id={'range__' + weight.id}
                       checked={props.weights.indexOf(weight.id) >= 0} />
                <label
                  htmlFor={'range__' + weight.id}
                  onClick={() => { addRemoveWeights(weight.id) }}
                >{weight.title}</label>
              </li>
            })}
          </ul>
        </div>}
        {colors.length > 0 && <div className="filter-sidebar__item filter-sidebar__color-item">
          <h5 className="filter-sidebar__item-title">Colors</h5>
          <ul>
            {colors.map((color) => {
              return <li key={'color_' + color.id} className={'filter-sidebar__color-li'}>
                <input type="checkbox" id={'color__' + color.id}
                       checked={props.colors.indexOf(color.id) >= 0} />
                <label htmlFor={'color__' + color.id}
                       className={props.colors.indexOf(color.id) >= 0 ? 'active' : ''}
                       onClick={() => { addRemoveColor(color) }}>
                  {!!color.hex && <span className="checkbox-color"
                                        style={{backgroundColor: '#' + color.hex}} />}
                  {color.title}
                </label>
              </li>
            })}
          </ul>
        </div>}
        {!!(twoToneSelected && two_tones.length > 0) && <div className="filter-sidebar__item filter-sidebar__color-item">
          <h5 className="filter-sidebar__item-title">Two-tone</h5>
          <ul>
            {two_tones.map((color) => {
              return <li key={'color_' + color.id} className={'filter-sidebar__color-li'}>
                <input type="checkbox"
                       id={'twotone__' + color.id}
                       checked={props.twoTones.indexOf(color.id) >= 0} />
                <label htmlFor={'twotone__' + color.id}
                       className={props.twoTones.indexOf(color.id) >= 0 ? 'active' : ''}
                       onClick={() => { addRemoveTwoTone(color.id) }}>
                                            <span className="checkbox-color"
                                                  style={{backgroundImage: `url("${color.url}")`}} />
                  {color.title}
                </label>
              </li>
            })}
          </ul>
        </div>}

        {fibre.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Main Fiber</h5>
          <ul>
            {fibre.map((fibreItem) => {
              return <li key={'fibre_' + fibreItem.id}>
                <input type="checkbox"
                       id={'fibre__' + fibreItem.id}
                       checked={props.fibres.indexOf(fibreItem.id) >= 0} />
                <label
                  htmlFor={'fibre__' + fibreItem.id}
                  onClick={() => { addRemoveFibre(fibreItem.id) }}
                >{fibreItem.title}</label>
              </li>
            })}
          </ul>
        </div>}

        {tags.length > 0 && <div className="filter-sidebar__item">
          <h5 className="filter-sidebar__item-title">Tags</h5>
          <ul>
            {tags.map((tag) => {
              return <li key={'tag_' + tag.id}>
                <input type="checkbox"
                       id={'tag__' + tag.id}
                       checked={props.tags.indexOf(tag.id) >= 0} />
                <label
                  htmlFor={'tag__' + tag.id}
                  onClick={() => { addRemoveTags(tag.id) }}
                >{tag.title}</label>
              </li>
            })}
          </ul>
        </div>}
      </div>
    </div>
  </div>
}

export default Sidebar;
